export const UserRoleEnum = {
    ADMIN: 'admin',
    KITCHEN_WORKER: 'kitchen_worker',
    COURIER: 'courier',
    USER: 'user',
};
